import { Component } from 'react';
import { RefreshCw } from 'lucide-react';
import { isChunkLoadError } from '../lib/chunkLoadError';
import { Button } from './ui/button';
import { PAGE_SHELL } from './ui/skeleton';

class ChunkLoadErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { chunkError: false, hasError: false };
  }

  static getDerivedStateFromError(error) {
    if (isChunkLoadError(error)) {
      return { chunkError: true, hasError: false };
    }
    return { chunkError: false, hasError: true };
  }

  componentDidUpdate(prevProps) {
    const { resetKey } = this.props;
    if (resetKey !== prevProps.resetKey && (this.state.chunkError || this.state.hasError)) {
      this.setState({ chunkError: false, hasError: false });
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { chunkError, hasError } = this.state;
    const { children } = this.props;

    if (!chunkError && !hasError) {
      return children;
    }

    if (hasError) {
      return (
        <div className={PAGE_SHELL}>
          <div className="mx-auto max-w-lg px-4 py-16 text-center">
            <h1 className="text-xl font-bold text-brand-danger">Errore imprevisto</h1>
            <p className="mt-2 text-sm ba-muted">Qualcosa è andato storto. Prova a ricaricare la pagina.</p>
            <Button type="button" className="mt-6" onClick={this.handleReload}>
              <RefreshCw className="h-4 w-4" aria-hidden />
              Ricarica pagina
            </Button>
          </div>
        </div>
      );
    }

    return (
      <div className={PAGE_SHELL}>
        <div className="mx-auto max-w-lg px-4 py-16 text-center">
          <h1 className="text-xl font-bold text-[var(--ba-body-text)]">
            Aggiornamento in corso
          </h1>
          <p className="mt-2 text-sm ba-muted">
            Non è stato possibile caricare una parte dell&apos;applicazione. Succede spesso in
            locale dopo una ricompilazione: ricarica la pagina per continuare.
          </p>
          <Button type="button" className="mt-6" onClick={this.handleReload}>
            <RefreshCw className="h-4 w-4" aria-hidden />
            Ricarica pagina
          </Button>
        </div>
      </div>
    );
  }
}

export default ChunkLoadErrorBoundary;
